import * as React from 'react';

import { ButtonContainer, Button as EmbarkButton, Modal as EmbarkModal, ModalHeader as EmbarkModalHeader } from '@emburse/ui-core';

import { IConfirmModalBaseProps } from '.';

export interface IConfirmModalProps extends IConfirmModalBaseProps {
  headerText?: string;
  cancelText?: string;
  confirmText?: string;
  confirmButtonColor?: string;
  confirmButtonDisabled?: boolean;
  hideConfirmButton?: boolean;
  children: React.ReactNode;
  isLoading?: boolean;
  showClose?: boolean;
  inlineButtons?: React.ReactNode;
  centeredButtons?: React.ReactNode;
  hideCancelButton?: boolean;
  backdropClickClosesModal?: boolean;
}
export class ConfirmModal extends React.Component<IConfirmModalProps> {
  constructor(props: IConfirmModalProps) {
    super(props);
  }

  render() {
    const {
      closeModal,
      onConfirm,
      children,
      headerText,
      cancelText,
      confirmText,
      confirmButtonColor,
      confirmButtonDisabled,
      hideConfirmButton = false,
      isLoading,
      showClose,
      inlineButtons,
      centeredButtons,
      hideCancelButton = false,
      backdropClickClosesModal = false
    } = this.props;

    const header = headerText || 'Are you sure?';
    const cancelButtonText = cancelText || 'Cancel';
    const confirmButtonText = confirmText || 'Yes';
    const showFooterActions = !hideCancelButton || !hideConfirmButton || Boolean(inlineButtons) || Boolean(centeredButtons);

    return (
      <EmbarkModal
        style={{ zIndex: 1500 }}
        open={true}
        onClose={closeModal}
        modalHeader={<EmbarkModalHeader title={header} onCloseClicked={closeModal} showClose={showClose} />}
        isLoading={isLoading}
        className="confirm-modal"
        disableBackdropClick={backdropClickClosesModal}
      >
        {children}
        {showFooterActions && (
          <ButtonContainer
            data-testid="edit-email-modal-buttons"
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: '24px',
              paddingBottom: '8px'
            }}
          >
            <div style={{ alignSelf: 'flex-start' }}>{inlineButtons}</div>
            <div style={{ alignSelf: 'flex-end' }}>
              {!hideCancelButton && (
                <EmbarkButton type="button" variant="outlined" color="primary" onClick={closeModal} disabled={isLoading}>
                  {cancelButtonText}
                </EmbarkButton>
              )}
              {centeredButtons}
              {!hideConfirmButton && (
                <EmbarkButton
                  type="submit"
                  color={confirmButtonColor || 'primary'}
                  onClick={onConfirm}
                  disabled={confirmButtonDisabled || isLoading}
                  style={{ marginLeft: 8 }}
                >
                  {confirmButtonText}
                </EmbarkButton>
              )}
            </div>
          </ButtonContainer>
        )}
      </EmbarkModal>
    );
  }
}
